import {
  PAYMENT_TERMS_INDEX_REQUESTED,
  PAYMENT_TERMS_INDEX_SUCCESS,
  PAYMENT_TERMS_INDEX_FAILURE,

  PAYMENT_TERM_CREATE_REQUESTED,
  PAYMENT_TERM_CREATE_SUCCESS,
  PAYMENT_TERM_CREATE_FAILURE,

  PAYMENT_TERM_UPDATE_REQUESTED,
  PAYMENT_TERM_UPDATE_SUCCESS,
  PAYMENT_TERM_UPDATE_FAILURE,

  PAYMENT_TERM_DELETE_REQUESTED,
  PAYMENT_TERM_DELETE_SUCCESS,
  PAYMENT_TERM_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  paymentTerms: [],
  errors: null
};

const paymentTerms = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case PAYMENT_TERMS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        paymentTerms: [],
        status: 'requesting',
        errors: null,
      });

    case PAYMENT_TERMS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        paymentTerms: action.payload.payment_terms,
        errors: null
      });

    case PAYMENT_TERMS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        paymentTerms: [],
        errors: 'error here'
      });

    case PAYMENT_TERM_CREATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case PAYMENT_TERM_CREATE_SUCCESS:
      newState.isUpdating = false;
      newState.paymentTerms.push(action.paymentTerm.paymentTerm);
      return newState;

    case PAYMENT_TERM_CREATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to create payment term';
      return newState

    case PAYMENT_TERM_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case PAYMENT_TERM_UPDATE_SUCCESS:
      newState.isUpdating = false;
      let toUpdate = newState.paymentTerms.findIndex(term => term.id === action.paymentTerm.paymentTerm.id);
      newState.paymentTerms[toUpdate] = action.paymentTerm.paymentTerm;
      return newState;

    case PAYMENT_TERM_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to update payment term';
      return newState;


    case PAYMENT_TERM_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.paymentTerms = newState.paymentTerms.filter(term => term.id !== action.paymentTermId);
      newState.errors = null;
      return newState;

    case PAYMENT_TERM_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case PAYMENT_TERM_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to delete payment term';
      return newState;


    default:
      return state;
  }
}

export default paymentTerms;